const COLORS = { lime: ["#D7FF5B", "#111"], pink: ["#FF7EC7", "#111"], sky: ["#7FD3FF", "#111"], black: ["#111", "#F4F3EC"] };

const Face = ({ fill, line, sleepy }) => (
  <svg viewBox="0 0 100 106" width="30" height="32" aria-hidden="true" className="shrink-0 drop-shadow-[1.5px_1.5px_0_#111]">
    <rect x="4" y="4" width="92" height="98" rx="21" fill={fill} stroke={sleepy ? "#F4F3EC" : "#111"} strokeWidth="7" />
    <path d={sleepy ? "M20 44L39 46" : "M20 42L39 43"} stroke={line} strokeWidth="8" strokeLinecap="round" />
    <path d={sleepy ? "M60 46L80 44" : "M57 39L82 28"} stroke={line} strokeWidth="8" strokeLinecap="round" />
    {[31, 69].map((cx) => sleepy ? (
      <path key={cx} d={`M${cx - 14} 63 Q${cx} 74 ${cx + 14} 63`} stroke={line} strokeWidth="6" fill="none" strokeLinecap="round" />
    ) : (
      <g key={cx}>
        <ellipse cx={cx} cy="63" rx="17" ry="11.5" fill="#fff" stroke="#111" strokeWidth="5" />
        <path d={`M${cx - 16.6} 60.7H${cx + 16.6}`} stroke="#111" strokeWidth="5.5" />
        <circle cx={cx + 7} cy="66.5" r="5.5" fill="#111" />
      </g>
    ))}
    {sleepy && <text x="74" y="26" fontFamily="Space Mono, monospace" fontWeight="700" fontSize="20" fill={line}>z</text>}
  </svg>
);

export const BadgeCharacter = ({ label, tone = "lime", testid, className = "" }) => {
  const [fill, line] = COLORS[tone];
  const sleepy = tone === "black";
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={testid} title={label}>
      <Face fill={fill} line={line} sleepy={sleepy} />
      <span className="relative rounded-[8px] border-[1.5px] border-ink bg-cloud px-1.5 py-[3px] font-mono text-[9px] font-bold uppercase leading-none tracking-[0.1em] text-ink shadow-[1.5px_1.5px_0_#111]">
        <span className="absolute -left-[5px] top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b-[1.5px] border-l-[1.5px] border-ink bg-cloud" aria-hidden="true" />
        <span className="relative">{label}</span>
      </span>
    </span>
  );
};
